import { CalendarClock, ExternalLink } from "lucide-react";

// When Priya shares her Google Calendar Appointment Schedule URL, drop it in here (or move to
// an environment variable). Until then, we render a graceful "coming soon" state.
const APPOINTMENT_SCHEDULE_URL = process.env.REACT_APP_APPOINTMENT_SCHEDULE_URL || "";

export default function AdminAppointments() {
  const hasUrl = !!APPOINTMENT_SCHEDULE_URL;

  return (
    <div data-testid="page-admin-appointments" className="space-y-6">
      {hasUrl ? (
        <EmbeddedSchedule url={APPOINTMENT_SCHEDULE_URL} />
      ) : (
        <div
          className="rounded-2xl border p-10 text-center"
          style={{ background: "#FAF6EC", borderColor: "rgba(27,67,50,0.12)" }}
          data-testid="appointments-placeholder"
        >
          <div
            className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full"
            style={{ background: "#fff", color: "#1B4332", border: "1px solid rgba(201,168,76,0.5)" }}
          >
            <CalendarClock size={22} />
          </div>
          <h3 className="font-serif text-2xl mt-5" style={{ color: "#1B4332" }}>
            Google Appointments &mdash; coming soon
          </h3>
          <p className="mt-3 max-w-md mx-auto text-sm" style={{ color: "#2A2621" }}>
            Once you share your Google Calendar Appointment Schedule URL, this page will embed the
            booking flow (with a graceful fallback that opens it in a new tab if Google blocks the
            embed). Google will keep handling availability, confirmations and reminders.
          </p>
          <p className="mt-4 text-xs" style={{ color: "#6E6759" }}>
            Add <code>REACT_APP_APPOINTMENT_SCHEDULE_URL</code> to <code>/app/frontend/.env</code>{" "}
            and restart the frontend to enable this.
          </p>
        </div>
      )}
    </div>
  );
}

function EmbeddedSchedule({ url }) {
  return (
    <div className="space-y-4" data-testid="appointments-embed">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm" style={{ color: "#2A2621" }}>
          Bookings are handled by Google Calendar. If the embed doesn&rsquo;t load, use the button
          on the right to open it in a new tab.
        </p>
        <a
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          className="btn-outline-forest"
          data-testid="appointments-open-external"
        >
          <ExternalLink size={14} /> Open in new tab
        </a>
      </div>
      <div
        className="rounded-2xl overflow-hidden border"
        style={{ borderColor: "rgba(27,67,50,0.12)", background: "#fff" }}
      >
        <iframe
          src={url}
          title="Google Appointment Schedule"
          className="w-full"
          style={{ height: "80vh", minHeight: 600, border: 0 }}
          data-testid="appointments-iframe"
        />
      </div>
    </div>
  );
}
